export enum BtnType {
  Danger = 'danger',
  IconOnly = 'icon-only',
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Warning = 'warning',
  IconOnlyTertiary = 'icon-only-tertiary',
}

export enum BtnSize {
  Large = 'lg',
  Small = 'sm',
  Full = 'full',
  TwoX = '2x',
}

export enum Icon {
  ArrowLeft = 'far fa-arrow-left fa-lg',
  ArrowRight = 'far fa-arrow-right fa-lg',
  Bars = 'fas fa-bars fa-2x',
  ChevronUp = 'far fa-chevron-up fa-lg',
  ChevronRight = 'far fa-chevron-right fa-lg',
  ChevronDown = 'far fa-chevron-down fa-lg',
  ChevronLeft = 'far fa-chevron-left fa-lg',
  Cloud = 'far fa-cloud-download fa-lg',
  Copy = 'fas fa-copy fa-2x',
  Danger = 'fas fa-exclamation-triangle fa-lg',
  Download = 'far fa-download fa-2x',
  DownloadArrowDown2X = 'fa-solid fa-arrow-down-to-bracket',
  DownloadArrowDown = 'fa-solid fa-lg fa-arrow-down-to-bracket',
  FileDownload = 'fal fa-2x fa-file-download',
  Envelope = 'far fa-envelope fa-lg',
  Pencil = 'fas fa-pencil fa-lg',
  Plus = 'far fa-plus fa-lg',
  SortDown = 'fas fa-sort-down fa-lg',
  Close = 'far fa-times fa-2x',
  Sync = 'far fa-sync fa-lg',
  Trash = 'fas fa-trash fa-lg',
}
